import { render, staticRenderFns } from "./ModalMessageViewDetails.vue?vue&type=template&id=36fd3e10&scoped=true"
import script from "./ModalMessageViewDetails.vue?vue&type=script&lang=js"
export * from "./ModalMessageViewDetails.vue?vue&type=script&lang=js"
import style0 from "./ModalMessageViewDetails.vue?vue&type=style&index=0&id=36fd3e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fd3e10",
  null
  
)

export default component.exports